// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e01b1032","977":"4e99c1de"}[chunkId] + ".chunk.js";
};